import { Link } from "react-router-dom";
import { MapPin, Mail, Phone } from "lucide-react";
import { useT } from "../../i18n/LanguageContext";
import { LOGO, CONTACT } from "./siteAssets";

const copy = {
  en: {
    blurb: "A U.S. 501(c)(3) nonprofit founded by survivor Sélifa Boukari McGreevy, working to end Female Genital Mutilation worldwide — beginning in Togo.",
    visit: "Visit",
    email: "Email",
    call: "Call",
    siteHeading: "Site",
    rights: "© 2026 Mother Hippo Foundation. A U.S. 501(c)(3) nonprofit. All rights reserved.",
    nav: {
      home: "Home",
      whoWeAre: "Who Are We",
      survivorStory: "Survivor Story",
      ourPlan: "Our Plan",
      ourProjects: "Our Projects",
      inTheNews: "In the News",
      sherifaFilm: "SHERIFA Film",
      donate: "Donate",
    },
  },
  fr: {
    blurb: "Une association à but non lucratif américaine 501(c)(3) fondée par la survivante Sélifa Boukari McGreevy, œuvrant à mettre fin aux mutilations génitales féminines dans le monde — à commencer par le Togo.",
    visit: "Adresse",
    email: "Courriel",
    call: "Téléphone",
    siteHeading: "Site",
    rights: "© 2026 Mother Hippo Foundation. Association à but non lucratif américaine 501(c)(3). Tous droits réservés.",
    nav: {
      home: "Accueil",
      whoWeAre: "Qui sommes-nous",
      survivorStory: "Témoignage",
      ourPlan: "Notre Plan",
      ourProjects: "Nos Projets",
      inTheNews: "Dans la presse",
      sherifaFilm: "Film SHERIFA",
      donate: "Donner",
    },
  },
};

export default function SiteFooter() {
  const t = useT(copy);
  return (
    <footer className="bg-[#1A0F0A] text-[#F4EDE0]/80 border-t border-[#F4EDE0]/10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <img src={LOGO} alt="Mother Hippo Foundation" className="h-14 w-auto object-contain" />
          <p className="mt-5 text-sm leading-relaxed text-[#F4EDE0]/70 max-w-xs">{t.blurb}</p>
          <div className="mt-6 inline-flex items-center gap-2 text-xs tracking-[0.3em] uppercase text-[#D4A93B] font-bold" data-testid="stories-footer-locations">
            <MapPin size={14} /> {CONTACT.locations}
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#D4A93B] font-bold flex items-center gap-2"><MapPin size={12} /> {t.visit}</div>
          <address className="mt-3 not-italic text-sm leading-relaxed whitespace-pre-line" data-testid="stories-footer-address">
            {CONTACT.address}
          </address>
        </div>

        <div className="md:col-span-3">
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#D4A93B] font-bold flex items-center gap-2"><Mail size={12} /> {t.email}</div>
          <a
            href={`mailto:${CONTACT.email}`}
            data-testid="stories-footer-email"
            className="mt-3 block text-sm break-all hover:text-[#D4A93B] transition-colors"
          >
            {CONTACT.email}
          </a>

          <div className="mt-6 text-[10px] tracking-[0.3em] uppercase text-[#D4A93B] font-bold flex items-center gap-2"><Phone size={12} /> {t.call}</div>
          <a
            href={`tel:${CONTACT.phone.replace(/[^+\d]/g, "")}`}
            data-testid="stories-footer-phone"
            className="mt-3 block text-sm hover:text-[#D4A93B] transition-colors"
          >
            {CONTACT.phone}
          </a>
        </div>

        <div className="md:col-span-2">
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#D4A93B] font-bold">{t.siteHeading}</div>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/" className="hover:text-[#D4A93B] transition-colors">{t.nav.home}</Link></li>
            <li><Link to="/who-we-are" className="hover:text-[#D4A93B] transition-colors">{t.nav.whoWeAre}</Link></li>
            <li><Link to="/survivor-story" className="hover:text-[#D4A93B] transition-colors">{t.nav.survivorStory}</Link></li>
            <li><Link to="/our-plan" className="hover:text-[#D4A93B] transition-colors">{t.nav.ourPlan}</Link></li>
            <li><Link to="/our-projects" className="hover:text-[#D4A93B] transition-colors">{t.nav.ourProjects}</Link></li>
            <li><Link to="/in-the-news" className="hover:text-[#D4A93B] transition-colors">{t.nav.inTheNews}</Link></li>
            <li><Link to="/sherifa-film" className="hover:text-[#D4A93B] transition-colors">{t.nav.sherifaFilm}</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#F4EDE0]/10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#F4EDE0]/60">
          <div data-testid="stories-footer-rights">{t.rights}</div>
          <Link to="/selector" className="hover:text-[#D4A93B] transition-colors">View prototype selector →</Link>
        </div>
      </div>
    </footer>
  );
}
